import React, { useEffect, useRef } from "react";
import { Animated, ViewStyle, TextStyle } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";

type Props = {
  status: "idle" | "uploading" | "analyzing";
  style?: TextStyle;
  containerStyle?: ViewStyle;
};

export const AnimatedStatusText: React.FC<Props> = ({
  status,
  style,
  containerStyle,
}) => {
  const fadeAnim = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    if (status === "idle") return;

    // Create a looping fade animation
    const fadeAnimation = Animated.loop(
      Animated.sequence([
        Animated.timing(fadeAnim, {
          toValue: 0.3,
          duration: 1000,
          useNativeDriver: true,
        }),
        Animated.timing(fadeAnim, {
          toValue: 1,
          duration: 1000,
          useNativeDriver: true,
        }),
      ])
    );

    fadeAnimation.start();

    return () => {
      fadeAnimation.stop();
      fadeAnim.setValue(1);
    };
  }, [status, fadeAnim]);

  if (status === "idle") return null;

  const statusText = status === "uploading" ? "Uploading..." : "Analyzing...";

  return (
    <Animated.View style={[containerStyle, { opacity: fadeAnim }]}>
      <Animated.Text style={[styles.defaultText, style]}>
        {statusText}
      </Animated.Text>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  defaultText: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 17,
    lineHeight: 25,
    color: "#151515",
    textAlign: "center",
  },
});
